import {
  createStore,
  compose,
  applyMiddleware,
  combineReducers,
  Store,
  Middleware,
  ReducersMapObject,
} from 'redux';
import thunk from 'redux-thunk';
import promise from 'redux-promise-middleware';
import {
  reducers as sharedReducers,
  middleware as sharedMiddleware,
} from './store';

const BROWSER_DEBUG =
  typeof window === 'undefined'
    ? false
    : typeof process.env.BROWSER_DEBUG !== 'undefined'
    ? process.env.BROWSER_DEBUG !== 'false' && !!process.env.BROWSER_DEBUG
    : process.env.NODE_ENV !== 'production';

const middlewares = [thunk, promise(), ...sharedMiddleware].filter(
  Boolean
) as Middleware[];

export const enhancers = [
  applyMiddleware(...middlewares),

  BROWSER_DEBUG &&
    window['__REDUX_DEVTOOLS_EXTENSION__'] &&
    window['__REDUX_DEVTOOLS_EXTENSION__'](),
].filter(Boolean);

const configureStore = (
  reducers: ReducersMapObject,
  preLoadedState?: any
): Store<any> =>
  createStore(
    combineReducers({ ...sharedReducers, ...reducers }),
    preLoadedState,
    compose(...enhancers)
  );

const initMiddleware = store => {
  store.dispatch({ type: 'INIT_MIDDLEWARE' });
  return store;
};

export default (
  reducers: ReducersMapObject,
  preLoadedState?: any
): Store<any> => initMiddleware(configureStore(reducers, preLoadedState));
